<template>
  <div class="find-pwd-ok">
    <h1>忘记密码</h1>
    <h2>Forget the password</h2>
    <div class="find-pwd-ok-form form-wrap">
      <img class="ok-img" src="../../assets/ok.png" alt>
      <p class="ok-tip">您的密码已重制，请重新登录</p>
      <button class="login-btn" @click="signIn">重新登录</button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'find-pwd-ok',
  data() {
    return {}
  },
  methods: {
    signIn() {
      this.$router.push({ path: '/login' })
    }
  }
}
</script>
<style lang="less" scoped>
.find-pwd-ok {
  h2 {
    margin-bottom: 60px;
  }
  .ok-img {
    width: 174px;
  }
  .ok-tip {
    margin-top: 30px;
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
